export const MAX_DREAM_RATE_COUNT = 50
